import {
  createBaseThemeOptions,
  createUnifiedTheme,
  genPageTheme,
  palettes,
  shapes,
} from '@backstage/theme';

import RobotoBold from '../assets/fonts/roboto/Roboto-Bold.ttf';
import RobotoBoldItalic from '../assets/fonts/roboto/Roboto-BoldItalic.ttf';
import RobotoRegular from '../assets/fonts/roboto/Roboto-Regular.ttf';
import RobotoRegularItalic from '../assets/fonts/roboto/Roboto-Italic.ttf';

const robotoRegular = {
  fontFamily: 'Roboto-Regular',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: `
      local('Roboto-Regular'),
      url(${RobotoRegular}) format('ttf'),
    `,
};

const robotoRegularItalic = {
  fontFamily: 'Roboto',
  fontStyle: 'italic',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: `
      local('Roboto-RegularItalic'),
      url(${RobotoRegularItalic}) format('ttf'),
    `,
};

const robotoBold = {
  fontFamily: 'Roboto',
  fontStyle: 'regular',
  fontDisplay: 'swap',
  fontWeight: 700,
  src: `
      local('Roboto-Bold'),
      url(${RobotoBold}) format('ttf'),
    `,
};

const robotoBoldItalic = {
  fontFamily: 'Roboto',
  fontStyle: 'italic',
  fontDisplay: 'swap',
  fontWeight: 700,
  src: `
      local('Roboto-BoldItalic'),
      url(${RobotoBoldItalic}) format('ttf'),
    `,
};


export const customLightTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.light,
      primary: {
        main: '#01bfb3',
        contrastText: '#f8f8f8',
      },
      secondary: {
        main: '#9339ab',
        contrastText: '#f8f8f8',
      },
      fontFamily: 'Roboto',
    },
  }),
  pageTheme: {
    home: genPageTheme({ colors: ['#01bfb3', '#9339ab', '#2e75cd'], shape: shapes.wave }),
    documentation: genPageTheme({
      colors: ['#01bfb3', '#9339ab', '#2e75cd'],
      shape: shapes.wave2,
    }),
    tool: genPageTheme({ colors: ['#01bfb3', '#9339ab', '#2e75cd'], shape: shapes.round }),
    service: genPageTheme({
      colors: ['#01bfb3', '#9339ab', '#2e75cd'],
      shape: shapes.wave,
    }),
    website: genPageTheme({
      colors: ['#01bfb3', '#9339ab', '#2e75cd'],
      shape: shapes.wave,
    }),
    library: genPageTheme({
      colors: ['#01bfb3', '#9339ab', '#2e75cd'],
      shape: shapes.wave,
    }),
    other: genPageTheme({ colors: ['#01bfb3', '#9339ab', '#2e75cd'], shape: shapes.wave }),
    app: genPageTheme({ colors: ['#01bfb3', '#9339ab', '#2e75cd'], shape: shapes.wave }),
    apis: genPageTheme({ colors: ['#01bfb3', '#9339ab', '#2e75cd'], shape: shapes.wave }),
  },
  defaultPageTheme: 'home',
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '@font-face': [robotoRegular, robotoRegularItalic, robotoBold, robotoBoldItalic],
      },
    }
  },
});

export const customDarkTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.dark,
      primary: {
        main: '#9339ab',
      },
      secondary: {
        main: '#01bfb3',
      },
      fontFamily: 'Roboto',
    }
  }),
  defaultPageTheme: 'home',
    components: {
    MuiCssBaseline: {
      styleOverrides: {
        '@font-face': [robotoRegular, robotoRegularItalic, robotoBold, robotoBoldItalic],
      },
    }
  },
pageTheme: {
    home: genPageTheme({ colors: ['#01bfb3', '#9339ab', '#2e75cd'], shape: shapes.wave }),
    documentation: genPageTheme({
      colors: ['#01bfb3', '#9339ab', '#2e75cd'],
      shape: shapes.wave2,
    }),
    tool: genPageTheme({ colors: ['#01bfb3', '#9339ab', '#2e75cd'], shape: shapes.round }),
    service: genPageTheme({
      colors: ['#01bfb3', '#9339ab', '#2e75cd'],
      shape: shapes.wave,
    }),
    website: genPageTheme({
      colors: ['#01bfb3', '#9339ab', '#2e75cd'],
      shape: shapes.wave,
    }),
    library: genPageTheme({
      colors: ['#01bfb3', '#9339ab', '#2e75cd'],
      shape: shapes.wave,
    }),
    other: genPageTheme({ colors: ['#01bfb3', '#9339ab', '#2e75cd'], shape: shapes.wave }),
    app: genPageTheme({ colors: ['#01bfb3', '#9339ab', '#2e75cd'], shape: shapes.wave }),
    apis: genPageTheme({ colors: ['#01bfb3', '#9339ab', '#2e75cd'], shape: shapes.wave }),
  },
});